// Bundled fallback content in the same shape as GET /api/content. The backend is the
// source of truth; this guarantees instant first paint and resilience if the API is slow.
import { pData, P_ORDER, lessons as lessonArr, faqs as faqArr, TIME_SLOTS, PRICE_LABEL, LINKS } from "./content";

export const SITE_DEFAULTS = {
  price: PRICE_LABEL,
  bookingCta: "Book a 5Ps Conversation",
  links: LINKS,
  timeSlots: TIME_SLOTS,
  siteMode: "live",
  previewActive: false,
  comingSoon: {
    kicker: "CAMPUS2CORP • A TRANSITIONWORKS INITIATIVE",
    headline: "From Campus to Corporate.",
    subline: "52 Lessons. 5Ps. One Journey.",
    body: "Scott Tang is putting the finishing touches on the eBook and the 5Ps learning journey. Leave your email and be the first to know when it opens.",
    cta: "Notify me at launch",
    thanks: "You are on the list. We will email you the moment the eBook is live.",
  },
  testimonials: {
    eyebrow: "What early readers say",
    heading: "Small lessons. Real shifts.",
    items: [
      { quote: "I read the First 90 Days lesson the week I started. It changed how I asked questions and how fast people trusted me.", name: "Sample reader", role: "Fresh graduate, Singapore" },
      { quote: "Profit coming last finally made money make sense. I set up my first emergency fund the same month.", name: "Sample reader", role: "Young working adult" },
      { quote: "The reflection prompts are the real value. One question a week is more useful than another hour of scrolling.", name: "Sample reader", role: "Final-year undergraduate" },
    ],
  },
  brandStory: {
    eyebrow: "The story behind the name",
    heading: "Why it's called TransitionWorks",
    lead: "Life is a series of transitions. TransitionWorks exists to help people move through the important ones with greater clarity, confidence and practical knowledge.",
    items: [
      { term: "TransitionWorks", meaning: "The work of transition", text: "The name reflects the work involved in navigating change. More than a label, it stands for a space and a set of tools that help you actively engage with life's big shifts, turning what often feels daunting into something manageable and productive." },
      { term: "Campus2Corp", meaning: "Where the journey begins", text: "One of the earliest major transitions is the move from Campus to Corporate, from the structure of academic life into the less structured realities of work. Campus2Corp names that journey, and it is where this eBook focuses first." },
    ],
    promiseLabel: "Brand promise",
    promise: "Helping people navigate life's important transitions with confidence.",
    themeLabel: "Brand theme",
    theme: "From Potential to Performance",
  },
  sample: {
    eyebrow: "Not ready to buy yet?",
    heading: "Read one lesson free.",
    body: "Get the First 90 Days lesson, with its reflection question, delivered to your inbox. See how the eBook thinks before you decide.",
    cta: "Send me the free lesson",
    lessonTitle: "First 90 Days",
  },
  hero: {
    kicker: "CAMPUS2CORP • A TRANSITIONWORKS INITIATIVE",
    eyebrow: "From Campus to Corporate",
    titleLine1: "Your Next Chapter",
    titleLine2: "Starts Here.",
    lead: "52 practical lessons. 5Ps. One journey. Built for undergraduates, fresh graduates and young working adults who want to navigate the first years of work with more clarity, confidence and purpose.",
    byline: "By Scott Tang • TransitionWorks",
    primaryCta: "Get the eBook Now",
    secondaryCta: "Take the 2-Min 5Ps Quiz",
    microcopy: "Less than the price of a coffee. Read on any device. Keep it for every transition ahead.",
  },
  fivePs: {
    eyebrow: "The TransitionWorks 5Ps",
    headingTop: "A More Meaningful Career.",
    headingBottom: "A Richer Life.",
    lead: "The 5Ps connect immediate workplace lessons with bigger questions about direction, relationships, growth, lifestyle and financial resources.",
    order: P_ORDER,
    items: pData,
  },
  offer: {
    eyebrow: "Why buy it when the TikTok videos are free?",
    headingPre: "Because the eBook turns ",
    headingHighlight: "52 separate lessons",
    headingPost: " into one connected journey.",
    lead: "The free videos are designed for discovery. The eBook organises the ideas around the 5Ps, adds deeper context, and gives you prompts that help you apply the lessons to your own situation rather than just scroll past them.",
    benefits: [
      "52 practical Campus2Corp lessons in one place",
      "The full Purpose to People to Program to Place to Profit framework",
      "Workplace, confidence, relationship, habit and money topics",
      "Reflection prompts so the lessons feel actionable, not abstract",
    ],
    valueNote: "The value is not more content. It is clarity, structure and connection.",
    includeBadge: "Includes a 1:1 5Ps Conversation with Scott",
    priceKicker: "Complete digital eBook",
    priceSub: "One-time purchase · Digital access after successful payment · No subscription",
    trustLine: "Secure checkout by Stripe · Instant download · Works on phone, tablet and desktop",
    primaryCta: "Get From Campus to Corporate",
  },
  scott: {
    eyebrow: "Meet Scott Tang",
    heading: "Decades of corporate experience, translated into practical lessons for the next generation.",
    lead: "Scott brings more than two decades of corporate and commercial experience across business development, strategic partnerships, relationship management and growth-focused roles.",
    paragraphs: [
      "Over the course of his career, he has worked across client-facing and leadership environments where trust, communication, judgment, adaptability and long-term relationship building matter. He also served as a Strategic Partnership Director in the finance industry, giving him first-hand exposure to how partnerships are built, how opportunities are developed and how professionals navigate complex business environments.",
      "Campus2Corp is his way of turning that experience into practical reflections for undergraduates, fresh graduates and young working adults. The focus is not on theory for theory's sake. It is on the real situations people encounter early in their careers: asking better questions, building trust, handling feedback, taking initiative, communicating clearly, managing relationships, developing stronger habits and making more intentional decisions.",
    ],
    signoffName: "Scott Tang",
    signoffTitle: "Founder, TransitionWorks",
    signoffSub: "Creator of Campus2Corp and the TransitionWorks 5Ps learning journey",
  },
  lessons: lessonArr.map(([category, title, text, question]) => ({ category, title, text, question })),
  faqs: faqArr.map(([q, a]) => ({ q, a })),
  images: { logoDark: null, logoLight: null, cover: null, scott: null, icon: null },
  ebook: { custom: false, filename: null },
};
